import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var CabaretIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M18.768.134a1 1 0 00-1 1.732l3.464 2a1 1 0 001-1.732l-3.464-2zM15.993 1.884A1 1 0 0014 2v2h-4V2l-.007-.116A1 1 0 008 2v2l.005.15A2 2 0 0010 6h4l.15-.005A2 2 0 0016 4V2l-.007-.116z"
                        }),
                        _jsx("path", {
                            d: "M12 3.2A1.1 1.1 0 1012 1a1.1 1.1 0 000 2.2z"
                        }),
                        _jsx("path", {
                            d: "M3.506 9.134a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm3 0a.5.5 0 10-1 0 .5.5 0 001 0zM18.006 6.634a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm0 2a.5.5 0 110 1 .5.5 0 010-1z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M14.1 11.03a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM16.1 14.03a1.1 1.1 0 110-2.2 1.1 1.1 0 010 2.2zM21 9.93a1.1 1.1 0 102.2 0 1.1 1.1 0 00-2.2 0zM20.1 14.03a1.1 1.1 0 110-2.2 1.1 1.1 0 010 2.2zM3.2 9.93a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0z"
                        }),
                        _jsx("path", {
                            d: "M3.506 18.134a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm3 0a.5.5 0 10-1 0 .5.5 0 001 0z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M3.2 18.93a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM3 21.93a1.1 1.1 0 102.2 0 1.1 1.1 0 00-2.2 0zM10.1 20.03a1.1 1.1 0 110-2.2 1.1 1.1 0 010 2.2zM7 21.93a1.1 1.1 0 102.2 0 1.1 1.1 0 00-2.2 0z"
                        }),
                        _jsx("path", {
                            d: "M18.006 15.634a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm0 2a.5.5 0 110 1 .5.5 0 010-1z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M14.1 20.03a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM16.1 23.03a1.1 1.1 0 110-2.2 1.1 1.1 0 010 2.2zM21 18.93a1.1 1.1 0 102.2 0 1.1 1.1 0 00-2.2 0zM20.1 23.03a1.1 1.1 0 110-2.2 1.1 1.1 0 010 2.2zM4.1 14.03a1.1 1.1 0 110-2.2 1.1 1.1 0 010 2.2zM10.1 11.03a1.1 1.1 0 110-2.2 1.1 1.1 0 010 2.2zM8.1 14.03a1.1 1.1 0 110-2.2 1.1 1.1 0 010 2.2z"
                        })
                    ]
                })
            })
        ]
    });
};
CabaretIcon.isCarinaIcon = true;
export default CabaretIcon;
